export const VARIANT = `fragment Variant on ProductVariant {
  id
  sku
  image {
    altText
    url(transform: { maxWidth: 500 })
  }
  availableForSale
  compareAtPrice { amount }
  price { amount }
  selectedOptions { value, name }
  product { id, title }
  textBadge: metafield(namespace: "acf_pdp", key: "variant_badge_messaging") { value }
  color_pattern: metafield(key: "color_pattern", namespace: "filter") { value }
  size_grouping: metafield(key: "size_grouping", namespace: "filter") { value }
  pattern_category: metafield(key: "pattern_category", namespace: "filter") { value }
  hoverImage: metafield(key: "hover_lifestyle_image", namespace: "acf_pdp") {
    reference {
      ... on MediaImage {
        image {
          url(
            transform: { maxWidth: 500 }
          )
        }
      }
    }
  }
}`;

export const PRODUCT_CARD = `fragment ProductCard on Product {
  title
  id
  handle
  tags
  type: productType
  options { name, values }
  priceRange { 
  minVariantPrice { 
        amount
      } 
  maxVariantPrice {
        amount
      }
  }
  shortDescription: metafield(namespace: "acf_pdp", key: "description_short") {
    value
  }
  fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
    value
  }
  textBadge: metafield(namespace: "acf_pdp", key: "badge_text_2") {
    value
  }
  imageBadge: metafield(namespace: "custom", key: "badge_award_asset") {
    reference {
      ... on MediaImage {
        image {
          url
        }
      }
    }
  }
  variants (first: $variantsRetrieved) {
    nodes {
      ... Variant
    }
  }
  featuredSku: metafield(namespace: "acf_pdp", key: "featured_sku") {
    reference {
      ... Variant
    }
  }
}${VARIANT}`;

export const PRODUCTS_FROM_COLLECTION_QUERY = `
query ProductsFromCollection($handle: String!, $first: Int!, $after: String, $filters: [ProductFilter!], $sortKey: ProductCollectionSortKeys!, $variantsRetrieved: Int!) {
  collection(handle: $handle) {
    id
    title
    products(first: $first, after: $after, sortKey:$sortKey, filters: $filters) {
      pageInfo {
        hasNextPage
        endCursor
      }
      filters {
        label
        id
        values {
          label
          id
          input
          swatch {
            color
            image {
              data: image {
                  url
              }
            }
          }
        }
      }
      edges {
        cursor
        node {
          ... ProductCard
        }
      }
    }
  }
}${PRODUCT_CARD}`;

export const VARIANT_FROM_SELECTIONS = `query ProductCard($handle: String!, $options: [SelectedOptionInput!]!) {
  product(handle: $handle) {
    variantBySelectedOptions(selectedOptions: $options) {
      ... Variant
    }
  }
}${VARIANT}`;

export const FACET_DETAILS_QUERY = `query FacetDetails($handle: String!, $type: String!) {
  metaobject(handle: { handle: $handle, type: $type }) {
    fields {
      key
      value
    }
  }
}`;

export const MEDIA_FIELDS = `fragment MediaImageFields on MediaImage {
  image {
    url
  }
}`;

export const VIDEO_FIELDS = `fragment VideoFields on Video {
  previewImage {
    url
    altText
  }
  sources {
    mimeType
    url
  }
}`;

export const CONTENT_MODAL = `fragment ContentModal on Metaobject {
  fields {
    key
    value
    reference {
      __typename
      ...MediaImageFields
      ...VideoFields
    }
  }
}${MEDIA_FIELDS}${VIDEO_FIELDS}`;

export const SHOP_THE_LOOK = `fragment ShopTheLook on Metaobject {
  field(key: "hotspots"){
    references(first:5){
      edges {
        node {
          ... on Metaobject {
            fields {
              key
              value
              reference {
                  ...MediaImageFields
                  ...Variant
              }
            }
          }
        }
      }
    }
  }
}${VARIANT}`;

export const CONTENT_CARD_QUERY = `query ContentCard($handle: String!) {
  product(handle: $handle) {
    hotspotData: metafield(key: "shop_the_look_hotspots", namespace: "custom"){
      references(first: 1) {
        edges {
            node {
              ... ShopTheLook
            }
        }
      }
    }
    contentModal: metafield(key: "content_card", namespace: "acf_pdp") {
      reference {
        ... ContentModal
      }
    }
  }
}${CONTENT_MODAL}${SHOP_THE_LOOK}`;
